import { Outlet } from "react-router-dom"

export default function AuthRouteContainer() {
    return (
        <>
            <Outlet />
        </>
    )
}
